export const pxToRem = (px: number, base: number = 16): number => {
	return (1 / base) * px;
};
